import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/pages/items/create-items/global'

export const CREATE_ITEMS_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
